<template>
  <div
    :class="[
      $style.base,
      {
        [$style.multiline]: multiline || $screen === 's'
      }
    ]"
  >
    <div :class="[$style.inner]">
      <div :class="$style.codeField">
        <BaseSpinner
          v-if="loading"
          inline
        />
        <BaseText
          v-else-if="code"
          color="secondary"
          v-test="'code-snippet'"
        >
          {{ code }}
        </BaseText>
        <div
          v-else
          :class="$style.center"
        >
          <BaseButton
            @click="$emit('generate')"
            v-test="'generateCode'"
          >
            {{ $t('custom_booking_widget.generate_code') }}
          </BaseButton>
        </div>
      </div>
      <div :class="$style.buttons">
        <BaseCopyButton
          :disabled="!code"
          :color="buttonColor"
          :value="code"
          @copy="emit('copy')"
          v-test="'test'"
        />
        <BaseButton
          v-if="isUrl"
          :disabled="!code"
          :color="buttonColor"
          icon="external_link"
          :href="code"
          v-test="'test'"
        >
          {{ $t('global.actions.open') }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
interface CodeFieldProps {
  code?: string;
  loading?: boolean;
  multiline?: boolean;
  buttonColor?: 'primary' | 'inverted';
  isUrl?: boolean;
}

withDefaults(defineProps<CodeFieldProps>(), {
  buttonColor: 'primary',
});

const emit = defineEmits(['generate', 'copy']);
</script>

<style
  lang="scss"
  module
>
.base {
  position: relative;
}

.inner {
  display: flex;
  align-items: center;
  padding: 0;

  .base.multiline & {
    flex-direction: column;
    align-items: stretch;
  }
}

.codeField {
  display: flex;
  align-items: center;
  background: var(--surface-secondary);
  padding: $spacing;
  margin-right: $spacing;
  border-radius: $radius;
  overflow-x: auto;
  white-space: pre;
  border: 1px dashed var(--border-strong);

  .base.multiline & {
    word-break: break-all;
    white-space: initial;
    margin-bottom: $spacing;
    margin-right: 0;
  }
}

.center {
  align-self: center;
}

.invisibleInput {
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
}

.buttons {
  display: flex;
  align-items: center;
  gap: $spacing;
  flex-wrap: wrap;
}
</style>
